/*jshint esversion: 11 */
import React, { useCallback, useState } from 'react';
import Select from 'react-select';
import { debounce } from 'lodash';
import { getParentList } from '../api/parent';

const PARENT_SEARCH_LIMIT = 50;

function mapParentsToOptions(list) {
  return (list || []).map((item) => ({
    value: item._id,
    label: item.name
  }));
}

const ParentSearchSelect = ({
  value,
  onChange,
  isDisabled = false,
  placeholder = 'Type to search parent...'
}) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchParentOptions = async (searchParam) => {
    setIsLoading(true);
    try {
      const response = await getParentList(
        1,
        PARENT_SEARCH_LIMIT,
        searchParam ? { filter_name: searchParam } : {}
      );
      setOptions(mapParentsToOptions(response?.data));
    } catch {
      setOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const searchParents = useCallback(
    debounce((inputValue) => {
      fetchParentOptions(inputValue);
    }, 300),
    []
  );

  return (
    <Select
      options={options}
      value={value || null}
      onChange={onChange}
      onInputChange={(inputValue, { action }) => {
        if (action === 'input-change') searchParents(inputValue);
      }}
      onMenuOpen={() => {
        if (!options.length) fetchParentOptions('');
      }}
      isLoading={isLoading}
      isDisabled={isDisabled}
      placeholder={placeholder}
      filterOption={() => true}
    />
  );
};

export default ParentSearchSelect;
